


import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { toast } from "react-toastify";
import Select from "react-select";

const MaterialIssueModal = ({ show, handleClose, onMaterialAdded }) => {
  const [material, setMaterial] = useState([]);
  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    material_id: "",
    quantity: "",
    unit_id: "",
    urgency: { value: "Normal", label: "Normal" },
    reason_id: "",
    notes: "",
  });


  const handleSelectChange = (name, option) => {
    setForm((prev) => ({ ...prev, [name]: option }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication token missing!");
      return;
    }

    try {
      const payload = {
        ...form,
        material_id: form.material_id?.value || "",
        unit_id: form.unit_id?.value || "",
        urgency: form.urgency?.value || "Normal",
        reason_id: form.reason_id?.value || "",
      };

      const response = await axios.post(
        `${config.API}/material/request_issue`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success(
          response.data.message || "Request submitted successfully!"
        );
        setForm({
          material_id: "",
          quantity: "",
          unit_id: "",
          urgency: "",
          reason_id: "",
          notes: "",
        });
        setErrors({});
        handleClose();
        onMaterialAdded();
        fetchMaterialList();
      } else {
        if (response.data.errors) {
          setErrors(response.data.errors);
        }
      }
    } catch (err) {
      console.error("Error submitting material issue:", err.message);
      toast.error("Failed to submit material issue request!");
    }
  };

  useEffect(() => {
    fetchMaterialList();
  }, []);

  const fetchMaterialList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.get(`${config.API}/material/master/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const formatted = response?.data?.materials.map((item) => ({
        value: item.id,
        label: item.material_name,
      }));
      setMaterial(formatted);
    } catch (err) {
      console.error("Error fetching materials:", err.message);
    }
  };

  const unitOptions = [
    { value: "1", label: "kg" },
    { value: "2", label: "pcs" },
    { value: "3", label: "m" },
    { value: "4", label: "l" },
    { value: "5", label: "ml" },
  ];

  const urgencyOptions = [
    { value: "Normal", label: "Normal" },
    { value: "Urgent", label: "Urgent" },
  ];

  const reasonOptions = [
    { value: "1", label: "Maintenance" },
    { value: "2", label: "Project" },
    { value: "3", label: "Replacement" },
  ];

  const formLabelCol = 2;
  const formInputCol = 10;

  return (
    <Modal show={show} onHide={handleClose} centered className="font_family">
      <Modal.Header closeButton className="border-0 p-4">
        <strong className="fs-4">Create Material Issue Request</strong>
      </Modal.Header>
      <Modal.Body className="p-4">
        <Form>
          {/* Material */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={formLabelCol}>
              Material
            </Form.Label>
            <Col sm={formInputCol}>
              <Select
                options={material}
                value={form.material_id}
                onChange={(material) => handleSelectChange("material_id", material)}
                placeholder="Select material"
                classNamePrefix={errors.material_id ? "is-invalid" : ""}
              />
              {errors.material_id && (
                <div className="text-danger small">{errors.material_id[0]}</div>
              )}
            </Col>
          </Form.Group>

          {/* Quantity + Unit */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={formLabelCol}>
              Quantity
            </Form.Label>
            <Col sm={formInputCol}>
              <Form.Control
                type="text"
                name="quantity"
                value={form.quantity}
                onChange={handleChange}
                className={errors.quantity ? "is-invalid" : ""}
              />
              {errors.quantity && (
                <div className="text-danger small">{errors.quantity[0]}</div>
              )}
            </Col>
            {/* <Form.Label column sm={formLabelCol}>
              Unit
            </Form.Label>
            <Col sm={4}>
              <Select
                options={unitOptions}
                value={form.unit_id}
                onChange={(unit) => handleSelectChange("unit_id", unit)}
                placeholder={form.unit_id ? form.unit_id.label : "Select unit"}
              />
              {errors.unit_id && (
                <div className="text-danger small">{errors.unit_id[0]}</div>
              )}
            </Col> */}
          </Form.Group>

          {/* Urgency */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={formLabelCol}>
              Urgency
            </Form.Label>
            <Col sm={formInputCol}>
              <Select
                options={urgencyOptions}
                value={form.urgency}
                placeholder="Select urgency"
                onChange={(urgency) => handleSelectChange("urgency", urgency)}
              />
            </Col>
          </Form.Group>

          {/* Reason */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={formLabelCol}>
              Reason
            </Form.Label>
            <Col sm={formInputCol}>
              <Select
                options={reasonOptions}
                value={form.reason_id}
                onChange={(reason) => handleSelectChange("reason_id", reason)}
                placeholder="Select reason"
              />
              {errors.reason_id && (
                <div className="text-danger small">{errors.reason_id[0]}</div>
              )}
            </Col>
          </Form.Group>

          {/* Notes */}
          <Form.Group as={Row}>
            <Form.Label column sm={formLabelCol}>
              Notes
            </Form.Label>
            <Col sm={formInputCol}>
              <Form.Control
                as="textarea"
                rows={3}
                name="notes"
                value={form.notes}
                onChange={handleChange}
                placeholder="Any additional information about this request"
              />
            </Col>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="outline-secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="dark" onClick={handleSubmit}>
          Submit Request
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MaterialIssueModal;
